// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"45868cef","58":"c6e8cae1","225":"b29f61b5","394":"6d154c01","466":"089b1ed5","676":"392847aa","787":"2d06c3a4","858":"44d2f6a3"}[chunkId] + ".chunk.js";
};